export default "__VITE_ASSET__DqMSQxND__"